import React, {useEffect, useState} from 'react';
import {isAdministrator} from "../framework/utils";
import {MENU_ADMIN_ITEMS} from "../framework/constants";
import {Grid} from "@mui/material";

export function Menu(props) {

  const [menu, setMenu] = useState([]);

  useEffect(() => {
    const hash = document.location.hash;
    let items = [];

    let menuItems = props.items;
    if (isAdministrator()) menuItems = [...menuItems, ...MENU_ADMIN_ITEMS];

    menuItems.forEach(item => {
      items.push({
        className: "u-mobile-fontsize12 u-nowrap App-menu" + (hash === item.url ? "-selected" : ""),
        label: item.label,
        url: item.url
      });
    });
    setMenu(items);
  }, [props.items]);

  return (
    <div>
      <Grid container={1} spacing={0}>
        {menu.map(entry => (
          <Grid item xs={4} md={12}>
            <div
              className={entry.className}
              onClick={() => { document.location.hash=entry.url; }}
            >
              {entry.label}
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
